export default {
  nome: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  document: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  numeroPA: {
    listOptions: [],
    value: null,
    selectedList: []
    // value: '',
    // maxlength: '30',
    // required: false,
    // state: null
  },
  nomeRegional: {
    listOptions: [],
    value: null,
    selectedList: []
    // value: '',
    // maxlength: '30',
    // required: false,
    // state: null
  },
  employee: {
    listOptions: [],
    selected: null,
    selectedList: []
  },
  groups: {
    listOptions: [],
    selected: null,
    selectedList: []
  },
  responsible: {
    listOptions: [],
    selected: null,
    selectedList: []
  },
  groupResponsible: {
    listOptions: [],
    selected: null,
    selectedList: []
  },
  product: {
    listOptions: [],
    selected: null,
    selectedList: []
  },
  valorInicial: {
    value: '',
    required: false,
    state: null
  },
  valorFinal: {
    value: '',
    required: false,
    state: null
  },
  origin: {
    listOptions: [],
    selected: null,
    selectedList: []
  },
  board: {
    listOptions: [],
    selected: null,
    selectedList: []
  },
  situacao: {
    value: null,
    selected: null,
    options: [{
      value: 1,
      text: 'ATIVO'
    },
    {
      value: 2,
      text: 'GANHO'
    },
    {
      value: 0,
      text: 'PERDIDO'
    },
    {
      value: 3,
      text: 'FINALIZADO'
    }],
    required: false,
    state: null
  },
  dataInicial: {
    value: '',
    required: false,
    state: null
  },
  dataFinal: {
    value: '',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/reports/crm/search/search-form.js